module.exports = __webpack_public_path__ + "957a6eb7d61a80acabff7bc348803f5f.jpg";